/**
 * This slice of theme is for defining component sizes. Chakra also defines more
 * {@link https://chakra-ui.com/docs/theming/theme#sizes}
 * Make sure you are using border-box in css
 */
const sizes = {
  // for buttons, inputs, etc
  inputlike: {
    xs: "1.625rem",
    sm: "2rem",
    md: "2.5rem",
    lg: "3rem"
  }
};

export default sizes;
